import axios from 'axios';
import { properties } from '../properties';

const API_BASE_URL = properties.backendApi;

// Create axios instance with base configuration
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor to include auth token
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor to handle auth errors
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('username');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const subjectService = {
  async getAllSubjects() {
    try {
      const response = await apiClient.get('/subjects');
      
      if (response.data.result === 'SUCCESS') {
        return response.data.data;
      } else {
        throw new Error(response.data.message || 'Failed to load subjects');
      }
    } catch (error) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw new Error('Failed to load subjects. Please try again.');
    }
  },

  async getSubjectById(subjectId) {
    try {
      const response = await apiClient.get(`/subjects/${subjectId}`);
      
      if (response.data.result === 'SUCCESS') {
        return response.data.data;
      } else {
        throw new Error(response.data.message || 'Failed to load subject');
      }
    } catch (error) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw new Error('Failed to load subject. Please try again.');
    }
  },

  async createSubject(subjectData) {
    try {
      const response = await apiClient.post('/subjects', subjectData);
      
      if (response.data.result === 'SUCCESS') {
        return response.data.data;
      } else {
        throw new Error(response.data.message || 'Failed to create subject');
      }
    } catch (error) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw new Error('Failed to create subject. Please try again.');
    }
  },

  async updateSubject(subjectId, subjectData) {
    try {
      const response = await apiClient.put(`/subjects/${subjectId}`, subjectData);
      
      if (response.data.result === 'SUCCESS') {
        return response.data.data;
      } else {
        throw new Error(response.data.message || 'Failed to update subject');
      }
    } catch (error) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw new Error('Failed to update subject. Please try again.');
    }
  },

  async deleteSubject(subjectId) {
    try {
      const response = await apiClient.delete(`/subjects/${subjectId}`);
      
      if (response.data.result !== 'SUCCESS') {
        throw new Error(response.data.message || 'Failed to delete subject');
      }
    } catch (error) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw new Error('Failed to delete subject. Please try again.');
    }
  },

  async updateSubjectOrder(subjectIds) {
    try {
      const response = await apiClient.put('/subjects/order', subjectIds);
      
      if (response.data.result !== 'SUCCESS') {
        throw new Error(response.data.message || 'Failed to update subject order');
      }
    } catch (error) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw new Error('Failed to update subject order. Please try again.');
    }
  },
};
